<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div class="w100">
      <div class="row mb-3">
        <div class="col-4">
          <label for="Label" class="form-label">会員向名称</label>
          <input
            type="text"
            class="form-control"
            id="Label"
            placeholder="会員向名称"
            v-model="article_obj.label"
          />
        </div>
        <div class="col-4">
          <label for="Label" class="form-label">管理用名称</label>
          <input
            type="text"
            class="form-control"
            id="manageLabel"
            placeholder="管理用名称"
            v-model="article_obj.manage_label"
          />
        </div>
        <div class="col-4">
          <label for="ArticleCd" class="form-label">商品CD</label>
          <input
            type="text"
            class="form-control"
            id="ArticleCd"
            placeholder="商品CD"
            v-model="article_obj.article_cd"
          />
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-4">
          <label for="CategoryId" class="form-label">商品カテゴリ</label>
          <bs-select
            :options="category_list"
            v-model="article_obj.category"
            :null-option="false"
            id="CategoryId"
            :classParam="'form-select'"
          ></bs-select>
        </div>
        <div class="col-4">
          <label for="LicenseId" class="form-label">ライセンス</label>
          <bs-select
            :options="license_cd_list(1, true)"
            v-model="article_obj.license_id"
            :null-option="false"
            id="LicenseId"
            :classParam="'form-select'"
          ></bs-select>
        </div>
        <div class="col-2">
          <label for="TaxRate" class="form-label">税率</label>
          <bs-select
            :options="tax_rate_list"
            v-model="article_obj.tax_rate"
            :null-option="false"
            id="TaxRate"
            :classParam="'form-select'"
          ></bs-select>
        </div>
        <div class="col-2">
          <label for="Sort" class="form-label">sort</label>
          <input
            type="number"
            class="form-control"
            id="Sort"
            placeholder="ソート"
            v-model="article_obj.sort"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-6"><h5>商品バリエーション</h5></div>
        <div
          class="col-2"
          v-for="tab_year in tab_year_add_list"
          :key="tab_year"
        >
          <div class="d-grid">
            <button
              type="button"
              :class="class_tab_year(tab_year.key)"
              @click="sel_tab(tab_year.key)"
            >
              {{ tab_year.label }}
            </button>
          </div>
        </div>
        <!-- <div class="col-1">
          <div class="d-grid">
            <button type="button" class="btn btn-outline-secondary" @click="add_variant">
              <i class="bi bi-plus"></i>
            </button>
          </div>
        </div> -->
      </div>
      <div class="mb-3">
        <div
          class=""
          v-for="year_add in target_sports_year_add_list"
          :key="year_add"
        >
          <div class="row mb-3 border-bottom border-dotted border-2 pb-3">
            <div class="col-1">
              <div class="d-grid">
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  @click="add_variant_(year_add.key, false)"
                >
                  <i class="bi bi-plus"></i>
                </button>
              </div>
            </div>
            <div class="col-11">
              <h5 class="pt-2">{{ year_add.label }}</h5>
            </div>
          </div>
          <div
            class="border-start border-4 ps-3 pb-3 mb-5"
            v-for="(variant, index) in variants_filter_year_add_key(
              year_add.key
            )"
            :key="variant"
          >
            <div class="row mb-2">
              <div class="col-11">
                <div style="font-weight: bold">
                  No.{{ index + 1 }}-{{ variant.id }}
                </div>
              </div>
              <div class="col-1">
                <div class="d-grid">
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    @click="del_variant(variant.variant_id, index)"
                  >
                    <i class="bi bi-x"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-4">
                <label for="Label" class="form-label">名称</label>
                <input
                  type="text"
                  class="form-control"
                  id="Label"
                  placeholder="名称"
                  v-model="variant.sub_label"
                />
              </div>
              <div class="col-4">
                <label for="manage_Label" class="form-label">管理用名称</label>
                <input
                  type="text"
                  class="form-control"
                  id="manage_Label"
                  placeholder="管理用名称"
                  v-model="variant.manage_label"
                />
              </div>
              <div class="col-4">
                <label for="SpecialCd" class="form-label">特別設定</label>
                <bs-select
                  :options="article_special_cd_list"
                  v-model="variant.special_cd"
                  :null-option="false"
                  id="SpecialCd"
                  :classParam="'form-select'"
                ></bs-select>
              </div>
              <!-- <div class="col-4">
                <label for="SportsYear" class="form-label">年度</label>
                  <bs-select
                      :options="sports_year_add_list"
                      v-model="variant.sports_year_add"
                      :null-option="false"
                      id="SportsYear"
                      :classParam="'form-select'"
                      ></bs-select>
              </div> -->
            </div>
            <div class="row mb-2">
              <div class="col-6">
                <label for="Description" class="form-label">注意文</label>
                <input
                  type="text"
                  class="form-control"
                  id="Description"
                  placeholder=""
                  v-model="variant.description"
                />
              </div>
              <div class="col-4">
                <label for="DefaultPrice" class="form-label">基本価格</label>
                <input
                  type="text"
                  class="form-control"
                  id="DefaultPrice"
                  placeholder=""
                  v-model="variant.default_price"
                />
              </div>
              <div class="col-2" v-if="(article_obj || {}).category == 1">
                <label for="Sort" class="form-label">保険タイプ</label>
                <bs-select
                  :options="insurance_type_list"
                  v-model="variant.sort"
                  :null-option="false"
                  id="Sort"
                  :classParam="'form-select'"
                ></bs-select>
              </div>
              <div class="col-2" v-else>
                <label for="Sort" class="form-label">ソートNo</label>
                <input
                  type="text"
                  class="form-control"
                  id="Sort"
                  placeholder=""
                  v-model="variant.sort"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-3">
                <label for="Age" class="form-label">年齢で制限</label>
                <div class="input-group">
                  <bs-select
                    :options="age_list"
                    v-model="variant.over_age"
                    :null-option="false"
                    id="Age1"
                    :classParam="'form-select'"
                  ></bs-select>
                  <span class="input-group-text">〜</span>
                  <bs-select
                    :options="age_list"
                    v-model="variant.under_age"
                    :null-option="false"
                    id="Age2"
                    :classParam="'form-select'"
                  ></bs-select>
                </div>
              </div>
              <div class="col-9">
                <label for="PriceConditionFlg" class="form-label"
                  >販売期間</label
                >
                <div class="input-group">
                  <div class="input-group-text">
                    <input
                      class="form-check-input mt-0"
                      type="checkbox"
                      v-model="variant.start_flg"
                      aria-label=""
                    />
                  </div>
                  <bs-select
                    :options="year_add_list"
                    v-model="variant.start_y_add"
                    :null-option="false"
                    id="StartYAdd"
                    :classParam="'form-select'"
                    v-if="variant.start_flg"
                  ></bs-select>
                  <bs-select
                    :options="mon_list"
                    v-model="variant.start_m"
                    :null-option="false"
                    id="StartM"
                    :classParam="'form-select'"
                    v-if="variant.start_flg"
                  ></bs-select>
                  <bs-select
                    :options="day_list"
                    v-model="variant.start_d"
                    :null-option="false"
                    id="StartD"
                    :classParam="'form-select'"
                    v-if="variant.start_flg"
                  ></bs-select>
                  <span class="input-group-text" v-if="variant.start_flg"
                    >〜</span
                  >
                  <span class="input-group-text" v-else>
                    ←開始期間を設定をするにはチェック
                  </span>
                  <div class="input-group-text">
                    <input
                      class="form-check-input mt-0"
                      type="checkbox"
                      v-model="variant.end_flg"
                      aria-label=""
                    />
                  </div>
                  <bs-select
                    :options="year_add_list"
                    v-model="variant.end_y_add"
                    :null-option="false"
                    id="EndYAdd"
                    :classParam="'form-select'"
                    v-if="variant.end_flg"
                  ></bs-select>
                  <bs-select
                    :options="mon_list"
                    v-model="variant.end_m"
                    :null-option="false"
                    id="EndM"
                    :classParam="'form-select'"
                    v-if="variant.end_flg"
                  ></bs-select>
                  <bs-select
                    :options="day_list"
                    v-model="variant.end_d"
                    :null-option="false"
                    id="EndD"
                    :classParam="'form-select'"
                    v-if="variant.end_flg"
                  ></bs-select>
                  <span class="input-group-text" v-else>
                    ←終了期間を設定をするにはチェック
                  </span>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-4">
                <label for="PriceConditionFlg" class="form-label"
                  >所有ライセンス別設定</label
                >
                <bs-select
                  :options="get_condition_flg_list"
                  v-model="variant.get_condition_flg"
                  :null-option="false"
                  id="PriceConditionFlg"
                  :classParam="'form-select'"
                ></bs-select>
              </div>
              <div class="col-4"></div>
              <div class="col-4">
                <label for="PriceConditionFlg" class="form-label"
                  >付与ライセンス</label
                >
                <bs-select
                  :options="license_cd_list(1, true)"
                  v-model="variant.sub_license_id"
                  :null-option="false"
                  id="LicenseId"
                  :classParam="'form-select'"
                ></bs-select>
              </div>
            </div>
            <div class="container mb-2" v-if="variant.get_condition_flg == 1">
              <div>ライセンス一覧</div>
              <div class="row">
                <div class="col-7 border-end">
                  <div class="row">
                    <div class="col-8">
                      <h5>競技ライセンス</h5>
                    </div>
                    <div class="col-2">
                      <div class="d-grid">
                        <button
                          @click="toggle_all_attach(1, variant.id, true)"
                          class="btn btn-sm btn-light btn-outline-secondary"
                        >
                          <i class="bi bi-check"></i>&nbsp;ON
                        </button>
                      </div>
                    </div>
                    <div class="col-2">
                      <div class="d-grid">
                        <button
                          @click="toggle_all_attach(1, variant.id, false)"
                          class="btn btn-sm btn-light btn-outline-secondary"
                        >
                          <i class="bi bi-square"></i>&nbsp;OFF
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-for="license_event_cd in license_event_cd_list"
                    :key="license_event_cd"
                  >
                    <div class="col-12">{{ license_event_cd.label }}</div>
                    <div
                      class="col-3 mb-2"
                      v-for="license_cd in license_cd_list_filters(
                        1,
                        license_event_cd.id
                      )"
                      :key="license_cd"
                    >
                      <div class="d-grid">
                        <button
                          type="button"
                          :class="
                            get_condition_btn_class(license_cd.id, variant.id)
                          "
                          @click="
                            attach_get_condition(license_cd.id, variant.id)
                          "
                        >
                          {{ license_cd.short_label }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3 border-end">
                  <div class="row">
                    <div class="col-6">
                      <h5>競技役員</h5>
                    </div>
                    <div class="col-3">
                      <div class="d-grid">
                        <button
                          @click="toggle_all_attach(4, variant.id, true)"
                          class="btn btn-sm btn-light btn-outline-secondary"
                        >
                          <i class="bi bi-check"></i>&nbsp;ON
                        </button>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="d-grid">
                        <button
                          @click="toggle_all_attach(4, variant.id, false)"
                          class="btn btn-sm btn-light btn-outline-secondary"
                        >
                          <i class="bi bi-square"></i>&nbsp;OFF
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-for="license_event_cd in license_event_cd_list"
                    :key="license_event_cd"
                  >
                    <div
                      class="col-12"
                      v-if="
                        typeof license_cd_list_filters(
                          4,
                          license_event_cd.id
                        ) === 'object' &&
                        license_cd_list_filters(4, license_event_cd.id).length >
                          0
                      "
                    >
                      {{ license_event_cd.label }}
                    </div>
                    <div
                      class="col-4 mb-2"
                      v-for="license_cd in license_cd_list_filters(
                        4,
                        license_event_cd.id
                      )"
                      :key="license_cd"
                    >
                      <div class="d-grid">
                        <button
                          type="button"
                          :class="
                            get_condition_btn_class(license_cd.id, variant.id)
                          "
                          @click="
                            attach_get_condition(license_cd.id, variant.id)
                          "
                        >
                          {{ license_cd.short_label }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <h5>講師</h5>
                    </div>
                    <div class="col-3">
                      <div class="d-grid">
                        <button
                          @click="toggle_all_attach(5, variant.id, true)"
                          class="btn btn-sm btn-light btn-outline-secondary"
                        >
                          <i class="bi bi-check"></i>&nbsp;ON
                        </button>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="d-grid">
                        <button
                          @click="toggle_all_attach(5, variant.id, false)"
                          class="btn btn-sm btn-light btn-outline-secondary"
                        >
                          <i class="bi bi-square"></i>&nbsp;OFF
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-for="license_event_cd in license_event_cd_list"
                    :key="license_event_cd"
                  >
                    <div
                      class="col-12"
                      v-if="
                        typeof license_cd_list_filters(
                          5,
                          license_event_cd.id
                        ) === 'object' &&
                        license_cd_list_filters(4, license_event_cd.id).length >
                          0
                      "
                    >
                      {{ license_event_cd.label }}
                    </div>
                    <div
                      class="col-4 mb-2"
                      v-for="license_cd in license_cd_list_filters(
                        5,
                        license_event_cd.id
                      )"
                      :key="license_cd"
                    >
                      <div class="d-grid">
                        <button
                          type="button"
                          :class="
                            get_condition_btn_class(license_cd.id, variant.id)
                          "
                          @click="
                            attach_get_condition(license_cd.id, variant.id)
                          "
                        >
                          {{ license_cd.short_label }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-2">
                  <h5>PIT・ENJOY</h5>
                  <div class="row">
                    <div
                      class="col-12 mb-2"
                      v-for="license_cd in license_cd_list_filters(
                        [2, 3],
                        false
                      )"
                      :key="license_cd"
                    >
                      <div class="d-grid">
                        <button
                          type="button"
                          :class="
                            get_condition_btn_class(license_cd.id, variant.id)
                          "
                          @click="
                            attach_get_condition(license_cd.id, variant.id)
                          "
                        >
                          {{ license_cd.short_label }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container mb-2">
              <div class="row">
                <div class="col-4">
                  <div class="d-grid">
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="add_variant_(year_add.key, index)"
                    >
                      このバリエーション(No.{{ index + 1 }})をコピー
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-for="(variant, index) in article_obj.variants"
        :key="variant"
        class="border-start border-4 ps-3 pb-3 mb-5 d-none"
      >
        <div class="row mb-2">
          <div class="col-11">
            <div style="font-weight: bold">
              No.{{ index + 1 }}-{{ variant.variant_id }}
            </div>
          </div>
          <div class="col-1">
            <div class="d-grid">
              <button
                type="button"
                class="btn btn-danger btn-sm"
                @click="del_variant(variant.variant_id, index)"
              >
                <i class="bi bi-x"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-4">
            <label for="Label" class="form-label">名称</label>
            <input
              type="text"
              class="form-control"
              id="Label"
              placeholder="名称"
              v-model="variant.sub_label"
            />
          </div>
          <div class="col-4">
            <label for="manage_Label" class="form-label">管理用名称</label>
            <input
              type="text"
              class="form-control"
              id="manage_Label"
              placeholder="管理用名称"
              v-model="variant.manage_label"
            />
          </div>
          <div class="col-4">
            <label for="SportsYear" class="form-label">年度</label>
            <bs-select
              :options="sports_year_add_list"
              v-model="variant.sports_year_add"
              :null-option="false"
              id="SportsYear"
              :classParam="'form-select'"
            ></bs-select>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6">
            <label for="Description" class="form-label">注意文</label>
            <input
              type="text"
              class="form-control"
              id="Description"
              placeholder=""
              v-model="variant.description"
            />
          </div>
          <div class="col-4">
            <label for="DefaultPrice" class="form-label">基本価格</label>
            <input
              type="text"
              class="form-control"
              id="DefaultPrice"
              placeholder=""
              v-model="variant.default_price"
            />
          </div>
          <div class="col-2">
            <label for="Sort" class="form-label">ソートNo</label>
            <input
              type="text"
              class="form-control"
              id="Sort"
              placeholder=""
              v-model="variant.sort"
            />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-3">
            <label for="Age" class="form-label">年齢で制限</label>
            <div class="input-group">
              <bs-select
                :options="age_list"
                v-model="variant.over_age"
                :null-option="false"
                id="Age1"
                :classParam="'form-select'"
              ></bs-select>
              <span class="input-group-text">〜</span>
              <bs-select
                :options="age_list"
                v-model="variant.under_age"
                :null-option="false"
                id="Age2"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
          <div class="col-9">
            <label for="PriceConditionFlg" class="form-label">販売期間</label>
            <div class="input-group">
              <div class="input-group-text">
                <input
                  class="form-check-input mt-0"
                  type="checkbox"
                  v-model="variant.start_flg"
                  aria-label=""
                />
              </div>
              <bs-select
                :options="year_add_list"
                v-model="variant.start_y_add"
                :null-option="false"
                id="StartYAdd"
                :classParam="'form-select'"
                v-if="variant.start_flg"
              ></bs-select>
              <bs-select
                :options="mon_list"
                v-model="variant.start_m"
                :null-option="false"
                id="StartM"
                :classParam="'form-select'"
                v-if="variant.start_flg"
              ></bs-select>
              <bs-select
                :options="day_list"
                v-model="variant.start_d"
                :null-option="false"
                id="StartD"
                :classParam="'form-select'"
                v-if="variant.start_flg"
              ></bs-select>
              <span class="input-group-text" v-if="variant.start_flg">〜</span>
              <span class="input-group-text" v-else>
                ←開始期間を設定をするにはチェック
              </span>
              <div class="input-group-text">
                <input
                  class="form-check-input mt-0"
                  type="checkbox"
                  v-model="variant.end_flg"
                  aria-label=""
                />
              </div>
              <bs-select
                :options="year_add_list"
                v-model="variant.end_y_add"
                :null-option="false"
                id="EndYAdd"
                :classParam="'form-select'"
                v-if="variant.end_flg"
              ></bs-select>
              <bs-select
                :options="mon_list"
                v-model="variant.end_m"
                :null-option="false"
                id="EndM"
                :classParam="'form-select'"
                v-if="variant.end_flg"
              ></bs-select>
              <bs-select
                :options="day_list"
                v-model="variant.end_d"
                :null-option="false"
                id="EndD"
                :classParam="'form-select'"
                v-if="variant.end_flg"
              ></bs-select>
              <span class="input-group-text" v-else>
                ←終了期間を設定をするにはチェック
              </span>
            </div>

            <!-- <div class="input-group">
              <input type="date" class="form-control" id="StartDate" placeholder="" v-model="variant.start_date_date">
              <span class="input-group-text">〜</span>
              <input type="date" class="form-control" id="EndDate" placeholder="" v-model="variant.end_date_date">
            </div> -->
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-4">
            <label for="PriceConditionFlg" class="form-label"
              >所有ライセンス別設定</label
            >
            <bs-select
              :options="get_condition_flg_list"
              v-model="variant.get_condition_flg"
              :null-option="false"
              id="PriceConditionFlg"
              :classParam="'form-select'"
            ></bs-select>
          </div>
          <div class="col-4"></div>
          <div class="col-4">
            <label for="PriceConditionFlg" class="form-label"
              >付与ライセンス</label
            >
            <bs-select
              :options="license_cd_list(1, true)"
              v-model="variant.sub_license_id"
              :null-option="false"
              id="LicenseId"
              :classParam="'form-select'"
            ></bs-select>
          </div>
        </div>
        <div class="container mb-2" v-if="variant.get_condition_flg == 1">
          <div>ライセンス一覧</div>
          <!-- license_event_cd_list_filter -->
          <!-- <div class="row" v-for="license_category in license_category_list" :key="license_category">
            <div class="col-12">{{ license_category.label }}</div>
          </div> -->
          <div class="row">
            <div class="col-7 border-end">
              <h5>競技ライセンス</h5>
              <div
                class="row"
                v-for="license_event_cd in license_event_cd_list"
                :key="license_event_cd"
              >
                <div class="col-12">{{ license_event_cd.label }}</div>
                <div
                  class="col-3 mb-2"
                  v-for="license_cd in license_cd_list_filters(
                    1,
                    license_event_cd.id
                  )"
                  :key="license_cd"
                >
                  <div class="d-grid">
                    <button
                      type="button"
                      :class="get_condition_btn_class(license_cd.id, index)"
                      @click="attach_get_condition(license_cd.id, index)"
                    >
                      {{ license_cd.short_label }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-3 border-end">
              <h5>競技役員</h5>
              <div
                class="row"
                v-for="license_event_cd in license_event_cd_list"
                :key="license_event_cd"
              >
                <div
                  class="col-12"
                  v-if="
                    typeof license_cd_list_filters(4, license_event_cd.id) ===
                      'object' &&
                    license_cd_list_filters(4, license_event_cd.id).length > 0
                  "
                >
                  {{ license_event_cd.label }}
                </div>
                <div
                  class="col-4 mb-2"
                  v-for="license_cd in license_cd_list_filters(
                    4,
                    license_event_cd.id
                  )"
                  :key="license_cd"
                >
                  <div class="d-grid">
                    <button
                      type="button"
                      :class="get_condition_btn_class(license_cd.id, index)"
                      @click="attach_get_condition(license_cd.id, index)"
                    >
                      {{ license_cd.short_label }}
                    </button>
                  </div>
                </div>
              </div>
              <h5>講師</h5>
              <div
                class="row"
                v-for="license_event_cd in license_event_cd_list"
                :key="license_event_cd"
              >
                <div
                  class="col-12"
                  v-if="
                    typeof license_cd_list_filters(5, license_event_cd.id) ===
                      'object' &&
                    license_cd_list_filters(4, license_event_cd.id).length > 0
                  "
                >
                  {{ license_event_cd.label }}
                </div>
                <div
                  class="col-4 mb-2"
                  v-for="license_cd in license_cd_list_filters(
                    5,
                    license_event_cd.id
                  )"
                  :key="license_cd"
                >
                  <div class="d-grid">
                    <button
                      type="button"
                      :class="get_condition_btn_class(license_cd.id, index)"
                      @click="attach_get_condition(license_cd.id, index)"
                    >
                      {{ license_cd.short_label }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-2">
              <h5>PIT・ENJOY</h5>
              <div class="row">
                <div
                  class="col-12 mb-2"
                  v-for="license_cd in license_cd_list_filters([2, 3], false)"
                  :key="license_cd"
                >
                  <div class="d-grid">
                    <button
                      type="button"
                      :class="get_condition_btn_class(license_cd.id, index)"
                      @click="attach_get_condition(license_cd.id, index)"
                    >
                      {{ license_cd.short_label }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-2 mb-2" v-for="license_cd in license_cd_list(false, false)" :key="license_cd">
              <div class="d-grid">
                <button type="button" :class="get_condition_btn_class(license_cd.id, index)" @click="attach_get_condition(license_cd.id, index)">
                  {{ license_cd.short_label }}
                </button>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-11"></div>
        <div class="col-1">
          <div class="d-grid">
            <button type="button" class="btn btn-outline-secondary" @click="add_variant">
              <i class="bi bi-plus"></i>
            </button>
          </div>
        </div>
      </div> -->

      <div class="mb-5"></div>
      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div
          class="col-12 col-sm-4 mb-2 text-center"
          v-if="chk_relation_type_editable('/article/data')"
        >
          <button type="submit" @click="update" class="btn btn-primary">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
// import Common from '../../../common/common'
import config from '../../../const'

export default {
  name: 'ArticleDetailView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: '商品マスタデータ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      category_obj: [],
      article_obj: {},
      license_cd_obj: [],
      license_event_cd_obj: [],
      license_category_obj: [],
      target_year_add: [0, 1, 2],
      article_special_cd_obj: [],
      insurance_type_obj: [],
      variant_frm_obj: {
        id: 0,
        sub_license_id: '',
        sub_label: '',
        manage_label: '',
        get_condition_flg: 0,
        special_cd: 0,
        default_price: '',
        // start_date_date: '',
        // end_date_date: '',
        start_y_add: 0,
        start_m: 0,
        start_d: 0,
        start_flg: false,
        end_y_add: 0,
        end_m: 0,
        end_d: 0,
        end_flg: false,
        sports_year_add: 0,
        over_age: '',
        under_age: '',
        get_condition: []
      },
      get_condition_frm_obj: {
        id: 0,
        article_id: this.$route.params.id,
        variant_id: 0,
        price: 0,
        license_id: 0
      },
      get_condition_flg_list: [
        {
          key: 0,
          label: '設定しない'
        },
        {
          key: 1,
          label: '設定する'
        }
      ],
      tax_rate_list: [
        {
          key: 0,
          label: '非課税'
        },
        {
          key: 10,
          label: '10%'
        }
      ]
    }
  },
  components: {
    BsPageTitle,
    BsSelect,
    BsMsgAlert
    // BsButton,
    // BsCheckBox,
  },
  methods: {
    sel_tab(tab_key) {
      if (tab_key == 2) {
        if (this.target_year_add.includes(tab_key)) {
          this.target_year_add = []
        } else {
          this.target_year_add = [0, 1, 2]
        }
      } else {
        if (this.target_year_add.includes(tab_key)) {
          this.target_year_add.splice(this.target_year_add.indexOf(tab_key), 1)
        } else {
          // this.target_year_add.push(tab_key);
          this.target_year_add = [tab_key]
        }
      }
    },
    // ConfigObjを読み込む別メソッドとして定義
    async loadConfigObj(param) {
      try {
        const response = await this.basicPosts_S(
          config.BASE_API_URL + '/config/' + param,
          {}
        )

        this[param + '_obj'] =
          response.data && response.data.body ? response.data.body : []
      } catch (err) {
        console.log(err)
        this[param + '_obj'] = []
      } finally {
        this.$forceUpdate()
      }
    },
    async loadCategoryList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/article_category/lists',
        params
      )
        .then(async response => {
          console.log('loadCategoryList response', response)
          this.category_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.category_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCategoryList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/license_category',
        params
      )
        .then(async response => {
          console.log('loadLicenseCategoryList response', response)
          this.license_category_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_category_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_event_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseEventCdList response', response)
          this.license_event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_event_cd_obj', err)
          this.license_event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/license_cd/lists', params)
        .then(async response => {
          console.log('loadLicenseCdList response', response)
          this.license_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_cd', err)
          this.license_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadArticleObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(config.BASE_API_URL + '/article/lists', params)
        .then(async response => {
          console.log('loadArticleObj', response)
          this.article_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
        })
        .catch(async err => {
          console.log(err)
          this.article_obj = {}
        })
        .finally(async () => {
          console.log('loadArticleObj finally', this.article_obj)
          if (
            typeof this.article_obj === 'object' &&
            typeof this.article_obj.variants === 'object' &&
            Object.keys(this.article_obj.variants).length <= 0
          ) {
            await this.add_variant()
            console.log('loadArticleObj finally2', this.article_obj.variants)
            console.log('loadArticleObj finally22', this.article_obj.variants)
          }
          this.$forceUpdate()
        })
    },
    async add_variant() {
      const variants_tmp = this.article_obj.variants
      variants_tmp.push({ ...this.variant_frm_obj })
      this.article_obj.variants = variants_tmp
    },
    async add_variant_(year_add, variant_index) {
      console.log('add_variant_', variant_index)
      const variants_tmp = [...this.article_obj.variants]
      const variants_filter_tmp = [
        ...this.variants_filter_year_add_key(year_add)
      ]
      const variants_cp =
        variant_index === false
          ? variants_tmp[variant_index]
          : variants_filter_tmp[variant_index]
      if (variants_cp) variants_cp.id = 0
      const tmp =
        variant_index === false
          ? { ...this.variant_frm_obj }
          : { ...variants_cp }
      tmp.sports_year_add = year_add
      const get_condition_tmp = [...tmp.get_condition]
      tmp.get_condition = [...get_condition_tmp]
      variants_tmp.push(tmp)
      this.article_obj.variants = variants_tmp
      if (variant_index !== false && variant_index >= 0) {
        alert('コピーしました')
      }
    },
    async del_variant(variant_id, v_index) {
      const variants_tmp = [...this.article_obj.variants]
      const index =
        variant_id > 0
          ? variants_tmp.findIndex(variant => variant.id == variant_id)
          : v_index
      if (variants_tmp[index] && variants_tmp[index].id > 0) {
        variants_tmp[index].stat = 9
        this.article_obj.variants = variants_tmp
        await this.update()
      } else {
        variants_tmp.splice(index, 1)
        this.article_obj.variants = variants_tmp
      }
    },
    async update() {
      console.log('component methods', this.article_obj)
      const post_url =
        this.article_obj.id > 0
          ? config.BASE_API_URL + '/article/edit/' + this.article_obj.id
          : config.BASE_API_URL + '/article/add'

      const params = this.article_obj
      let result = false
      await this.basicPosts_I(post_url, params)
        .then(async response => {
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            this.targetid = response.data.body[0].id
            this.alertMessage = this.btnLabel + 'しました'
            this.alertClass = 'alert-success'
            result = true
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            // this.targetid = add;
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
          } else {
            console.log('error update status 200 error')
            // this.targetid = 'add';
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
          }
        })
        .catch(err => {
          console.log(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          if (result) {
            await this.loadArticleObj()
          }
          this.$forceUpdate()
        })
      // return this.$store.dispatch('updateBasic', {data: this.article_obj, target: 'article'})
      //   .then(() => {
      //     this.alertMessage = this.btnLabel + 'しました';
      //     this.alertClass = 'alert-success';
      //   })
      //   .catch((err) => {
      //     Promise.reject(err);
      //     this.alertMessage = this.btnLabel + 'できませんでした';
      //     this.alertClass = 'alert-danger';
      //   })
      //   .finally(async () => {
      //     await this.loadArticleObj();
      //   })
    },
    async toggle_all_attach(license_category, variant_id, flg) {
      const license_cds = [...this.license_cd_obj].filter(
        cd => cd.license_category == license_category
      )

      await Promise.all(
        license_cds.map(async license_cd => {
          // ONにする
          if (flg == true && !this.chk_condition(license_cd.id, variant_id)) {
            return await this.attach_get_condition(license_cd.id, variant_id)
          }
          // OFFにする
          else if (
            flg == false &&
            this.chk_condition(license_cd.id, variant_id)
          ) {
            return await this.attach_get_condition(license_cd.id, variant_id)
          }
        })
      )
    },
    attach_get_condition(license_id, variant_id) {
      const variants = (this.article_obj || {}).variants
      const index = this.get_variant_index(variant_id)
      if (
        typeof index === 'number' &&
        this.chk_condition(license_id, variant_id)
      ) {
        const tar_index = variants[index].get_condition.findIndex(
          get_con => get_con.license_id == license_id
        )
        variants[index].get_condition.splice(tar_index, 1)
        this.article_obj.variants = variants
      } else if (
        typeof index === 'number' &&
        variants &&
        typeof variants === 'object' &&
        variants[index] &&
        typeof variants[index] === 'object'
      ) {
        const tmp = { ...this.get_condition_frm_obj }
        tmp.license_id = license_id
        variants[index].get_condition.push(tmp)
        this.article_obj.variants = variants
      }
      console.log('attach_get_condition', this.article_obj.variants)
    },
    back() {
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState({}),
    variants_filter_year_add_key: function () {
      const variants = (this.article_obj || {}).variants
      return function (year_add_key) {
        return (variants || []).filter(
          vrt => vrt.sports_year_add == year_add_key
        )
      }
    },
    chk_tab_selected: function () {
      const target_year_add = this.target_year_add
      return function (tab_key) {
        if (target_year_add.includes(tab_key)) {
          return true
        } else {
          return false
        }
      }
    },
    class_tab_year: function () {
      const chk = this.chk_tab_selected
      return function (tab_key) {
        if (chk(tab_key)) {
          return 'btn btn-light btn-outline-primary'
        } else {
          return 'btn btn-outline-secondary btn-light'
        }
      }
    },
    tab_year_add_list: function () {
      const start_year = 0
      const max_year = 1
      const labels = ['当年度', '次年度', '全て']
      const tmps = []
      for (let y = start_year; y <= max_year; y++) {
        tmps.push({
          key: y,
          label: labels[y]
        })
      }
      tmps.push({
        key: 2,
        label: labels[2]
      })
      return tmps
    },
    target_sports_year_add_list: function () {
      return [...this.sports_year_add_list].filter(year_add => {
        if (this.target_year_add.includes(parseInt(year_add.key))) {
          return true
        }
        return false
      })
    },
    sports_year_add_list: function () {
      const start_year = 0
      const max_year = 1
      const labels = ['当年度', '次年度']
      const tmps = []
      for (let y = start_year; y <= max_year; y++) {
        tmps.push({
          key: y,
          label: labels[y]
        })
      }
      return tmps
    },
    year_add_list: function () {
      const start_year = 0
      const max_year = 1
      const labels = ['当年', '次年']
      const tmps = []
      for (let y = start_year; y <= max_year; y++) {
        tmps.push({
          key: y,
          label: labels[y]
        })
      }
      return tmps
    },
    mon_list: function () {
      const start = 1
      const max = 12
      const tmps = []
      for (let i = start; i <= max; i++) {
        tmps.push({
          key: i,
          label: i + '月'
        })
      }
      return tmps
    },
    day_list: function () {
      const start = 1
      const max = 31
      const tmps = []
      for (let i = start; i <= max; i++) {
        tmps.push({
          key: i,
          label: i + '日'
        })
      }
      return tmps
    },
    age_list: function () {
      const tmps = []
      for (let i = 0; i < 18; i++) {
        tmps.push({
          key: i,
          label: i + '歳'
        })
      }
      tmps.push({
        key: 0,
        label: '設定しない'
      })
      for (let i = 18; i < 100; i++) {
        tmps.push({
          key: i,
          label: i + '歳'
        })
      }
      return tmps
    },
    insurance_type_list: function () {
      const lists = [...this.insurance_type_obj]
      return lists
    },
    get_condition_btn_class: function () {
      const chks = this.chk_condition
      return function (license_id, variant_id) {
        const chk = chks(license_id, variant_id)
        console.log('get_condition_btn_class', chk, license_id, variant_id)
        if (chk) {
          return 'btn btn-warning'
        }
        return 'btn btn-light btn-outline-secondary'
      }
    },
    get_variant_index: function () {
      const variants = (this.article_obj || {}).variants
      // const lists = ((this.article_obj || {}).variants || {}).get_condition;
      return function (variant_id) {
        const index = variants.findIndex(variant => variant.id == variant_id)
        if (index >= 0) {
          return index
        }
        return false
      }
    },
    chk_condition: function () {
      const variants = (this.article_obj || {}).variants
      const get_variant_index = this.get_variant_index
      // const lists = ((this.article_obj || {}).variants || {}).get_condition;
      return function (license_id, variant_id) {
        const index = get_variant_index(variant_id)
        if (
          typeof index === 'number' &&
          typeof variants === 'object' &&
          typeof variants[index] === 'object' &&
          variants[index] &&
          variants[index].get_condition &&
          variants[index].get_condition.find(
            get_con => get_con.license_id == license_id
          )
        ) {
          return true
        }
        return false
      }
    },
    category_list: function () {
      const lists = [...this.category_obj]
      return lists
        .map(list => {
          list.key = list.id
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    license_category_list: function () {
      return [
        {
          key: [1],
          label: '競技ライセンス'
        },
        {
          key: [4, 5],
          label: '役員・更新'
        },
        {
          key: [2, 3],
          label: 'PIT/エンジョイ'
        }
      ]
      // return [...this.license_category_obj].sort((a, b) => {
      //   if(parseInt(a.sort) < parseInt(b.sort)){
      //       return -1;
      //   }else{
      //       return 1;
      //   }
      // })
    },
    license_event_cd_list: function () {
      return [...this.license_event_cd_obj].sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    },
    license_event_cd_list_filter: function () {
      const tmps = [...this.license_event_cd_list]
      return function (license_category) {
        return tmps
          .filter(tmp => {
            if (license_category == false) {
              return true
            } else if (
              typeof license_category === 'object' &&
              license_category.includes(parseInt(tmp.license_category))
            ) {
              return true
            } else if (tmp.license_category == license_category) {
              return true
            }
          })
          .map(list => {
            list.key = list.id
            return list
          })
          .sort((a, b) => {
            if (parseInt(a.sort) < parseInt(b.sort)) {
              return -1
            } else {
              return 1
            }
          })
      }
    },
    license_cd_list_filters: function () {
      const tmps = this.license_cd_list(false, false)
      return function (license_category, license_event_id) {
        const lists = tmps
        return [...lists]
          .filter(list => {
            if (license_category == false) {
              return true
            } else if (
              typeof license_category === 'object' &&
              license_category.includes(parseInt(list.license_category))
            ) {
              return true
            } else if (list.license_category == license_category) {
              return true
            }
          })
          .filter(list => {
            if (license_event_id == false) {
              return true
            } else if (list.license_event_cd == license_event_id) {
              return true
            }
          })
          .map(list => {
            list.key = list.id
            return list
          })
          .sort((a, b) => {
            if (parseInt(a.sort) < parseInt(b.sort)) {
              return -1
            } else {
              return 1
            }
          })
      }
    },
    license_cd_list: function () {
      const not = [
        {
          sales_flg: 1,
          label: '付与しない',
          key: 0,
          id: 0,
          sort: 0
        }
      ]
      const tmps = [...this.license_cd_obj]

      return function (sales_flg, not_flg) {
        const lists = not_flg ? not.concat(tmps) : tmps
        return [...lists]
          .filter(list => {
            if (sales_flg == false) {
              return true
            } else if (list.sales_flg == sales_flg) {
              return true
            }
          })
          .map(list => {
            list.key = list.id
            return list
          })
          .sort((a, b) => {
            if (parseInt(a.sort) < parseInt(b.sort)) {
              return -1
            } else {
              return 1
            }
          })
      }
    },
    article_special_cd_list: function () {
      const tmps = [
        {
          key: 0,
          label: '未設定'
        }
      ].concat(this.article_special_cd_obj)
      return tmps
    }
  },

  async created() {
    await this.loadCategoryList()
    await this.loadLicenseCdList()
    await this.loadLicenseCategoryList()
    await this.loadLicenseEventCdList()
    await this.loadConfigObj('insurance_type')
    this.article_special_cd_obj = await this.getConfigAPI('article_special_cd')

    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      await this.loadArticleObj()
      this.btnLabel = '更新'
    } else {
      this.article_obj = {
        id: 0,
        label: '',
        manage_label: '',
        license_id: '',
        article_cd: '',
        category: '',
        tax_rate: 10,
        sort: 0,
        variants: []
      }
      this.btnLabel = '登録'
    }
    this.alertMessage = this.btnLabel + 'できます'
  },
  mounted: function () {
    this.fromParentTitle = '商品マスタデータ詳細'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
